<template>
  <div class="summary">
    <h2 class="title is-4">Summary</h2>
    <div class="mb-2">
      <h3 class="title is-4 mb-1">Vehicle</h3>
      <ChosenVehicle />
    </div>
    <div class="mb-2">
      <h3 class="title is-4 mb-1">Cover</h3>
      <ul>
        <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>{{ answerLabel('Vehicle.Quote','vehicle_cover_type') }}</li>
        <li v-if="answers[getStep('Vehicle.Quote')].vehicle_cover_type == 'full'"><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Nil-excess Windscreen &amp; Glass cover</li>
        <li v-if="answers[getStep('Vehicle.Quote')].vehicle_cover_type == 'full'">
          <svg v-if="answerLabel('Vehicle.Quote','vehicle_excess_under_25_note')" width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>
          <svg v-else width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_cross_icon" /></svg>Cover for drivers under 25 years
        </li>
        <li v-if="answers[getStep('Vehicle.Quote')].vehicle_cover_type == 'full'">
          <svg v-if="answers[getStep('Vehicle.Quote')].vehicle_include_roadside_assist_cover == 'yes'" width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>
          <svg v-else width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_cross_icon" /></svg>Roadside Assist
        </li>
      </ul>
    </div>
    <div class="mb-2">
      <h3 class="title is-4 mb-1">Excess<template v-if="answerLabel('Vehicle.Quote','vehicle_excess_under_25_note')">es</template></h3>
      <span>${{ excess }}</span>
      <span v-if="answerLabel('Vehicle.Quote','vehicle_excess_under_25_note')">${{ parseInt( excess ) + 500 }} for under 25 drivers</span>
      <span><a href="#" @click.prevent="toggleModal()">Additional excesses may apply</a></span>
      <modal
        v-if="modalOpen"
        :class="{ 'is-active': modalOpen }"
        v-on:childToParent="toggleModal"
        title="List of excesses"
        footer="Summary of policy only. Please refer to the policy wording for full details of cover."
      >
        <InitioExcesses />
      </modal>
    </div>
    <div class="mb-2">
      <h3 class="title is-4 mb-1">{{ paymentInterval(true) }} Payment</h3>
      <span>{{ answers[getStep('Vehicle.Quote')].vehicle_quote_premium_raw | toCurrency }} inc GST</span>
    </div>
    <div class="mb-2">
      <h3 class="title is-4 mb-1">Starting</h3>
      <span>{{ fulltextDate(answers[getStep('Vehicle.Confirm')].vehicle_confirm_insurance_start) }}</span>
    </div>
    <div class="mb-2" v-if="driver.first_name && driver.last_name">
      <h3 class="title is-4 mb-1">Main Driver</h3>
      <span>{{ driver['first_name'] }} {{
        driver['last_name'] }} - {{
        fulltextDate(driver['dob']) }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fulltextDate } from '@/helpers/dateHelper.js'
import ChosenVehicle from '@/components/initio/formulate/ChosenVehicle.vue'
import InitioExcesses from '@/components/partials/Excesses.vue'

export default {
  components: {
    ChosenVehicle,
    InitioExcesses
  },
  methods: {
    fulltextDate,
    toggleModal: function () {
        this.modalOpen = ! this.modalOpen;
    }
  },
  computed: {
    ...mapGetters({ driver: 'getDriver', answers: 'flattenedAnswers', answerLabel: 'getAnswerLabel', paymentInterval: 'getPaymentInterval', getStep: 'getStep' }),

    excess() {
      if (this.answers[this.getStep('Vehicle.Quote')].vehicle_excess) {
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_excess
      }
      if (this.answers[this.getStep('Vehicle.Quote')].vehicle_excess_third_party) {
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_excess_third_party;
      }
      return false;
    }
  },
  data () {
    return {
      modalOpen: false
    }
  },
  name: 'initio-summary'
}

</script>

<style scoped lang="scss">

  .summary {

    @import '~@/scss/partials/icons.scss';

    > h2 {
      font-size:1.5rem;
      font-weight:900;
    }
    h3 {
      padding:0.25rem 0;
      font-size:0.9rem;
    }
    span, ul li {
      min-height:1rem;
      display:block;
      color:rgba(113, 127, 134, 1);
      font-size:0.9rem;
    }
    .plate {
      text-transform: uppercase;
    }
  }

  ::v-deep {

    .chosen-vehicle-block {
      padding:0;
      background:none;
      border:none;
      // flex-wrap:wrap;

      .plate {
        background: #f3f3f3;
        border: 1px solid #dfe3e8;
      }

      .full_model {
        color:$grey-text;
        // flex-basis:100%;
        // padding-top:0.5rem;
      }

    }

  }

</style>